import React, { useEffect, useState } from "react";
import ReactGA from "react-ga4";
import { Footer, Header, HeadMetaTags, SearchBox } from "../components";
import { mostPopularCityData, primaryCities } from "../data/citiesData";
import { Link, useLocation } from "react-router-dom";
import Button from "../components/Button";

const Search = () => {
  const [citiesArray, setCitiesArray] = useState(primaryCities);
  const [showMore, setShowMore] = useState(false);
  const location = useLocation();
  const isTracking =
    process.env.REACT_APP_GA_TRACKING === "true" ? true : false;

  useEffect(() => {
    if (isTracking) {
      ReactGA.send({
        hitType: "pageview",
        page: location.pathname + location.search,
      });
    }
    // eslint-disable-next-line
  }, [location]);

  const handleGAEvent = (category, action, label) => {
    if (isTracking) {
      ReactGA.event({
        category,
        action,
        label,
      });
    }
  };

  return (
    <div className="overflow-hidden">
      <HeadMetaTags
        title={`Search Rooms for Rent | Roommates Made Simple`}
        description="Search for affordable rooms for rent in your area. The #1 fastest growing room rental app in the U.S., with 1000's of verified landlords."
        ogTitle={`Search Rooms for Rent on Snappily`}
      />
      <section>
        <Header />
      </section>
      <section className="mt-28">
        <div className="flex justify-center text-2xl mb-10">
          Find a room for rent
        </div>
        <SearchBox handleSearchDropdown={() => {}} showDropdown={false} />
      </section>
      <section className="w-full max-w-full mb-20 px-5">
        <div className="flex justify-center text-xl mt-10">
          Or browse by city
        </div>
        <div>
          <ul className="grid grid-cols-3 justify-items-center items-center gap-y-5 mt-10">
            {citiesArray.map((item, index) => {
              return (
                <li
                  key={item.id}
                  className=" text-center text-blue-500 hover:text-blue-700 cursor-pointer"
                >
                  {/* <Link
                    to={`/rooms?city=${item.city.toLowerCase()}&state=${item.state.toLowerCase()}&lat=${
                      item.latitude
                    }&long=${item.longitude}`}
                  >
                    {item.city}
                  </Link> */}
                  <Link to={`/search/${item.slug}`}>{item.city}</Link>
                </li>
              );
            })}
          </ul>
        </div>
        {!showMore && (
          <div className="flex justify-center mt-8">
            <Button
              background="bg-snappily-orange"
              text="text-white xs:text-base"
              opacity="bg-opacity-100"
              title="See More..."
              height="p-1"
              width=" "
              borderHover="hover:border-snappily-orange"
              customFunc={() => {
                setCitiesArray(mostPopularCityData);
                handleGAEvent("Button Click", "Click", "Show More Cities");
                setShowMore(true);
              }}
            />
          </div>
        )}
      </section>
      <section>
        <Footer />
      </section>
    </div>
  );
};

export default Search;
